/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type OnboardingHookEvent = {
  /**
   * Speakeasy chat/session ID that owns this event, when present.
   */
  chatId?: string | undefined;
  /**
   * Hook event name (e.g. PreToolUse, SessionStart).
   */
  eventName?: string | undefined;
  /**
   * Slug of the Speakeasy project that received the event.
   */
  projectSlug: string;
  /**
   * Hook source: claude_code, cursor, or codex.
   */
  source: string;
  /**
   * Outcome status: allowed, blocked, failure, or pending.
   */
  status?: string | undefined;
  /**
   * Event timestamp in nanoseconds since unix epoch. Stringified to preserve int64 precision.
   */
  timeUnixNano: string;
  /**
   * Tool invoked by the hook, if any.
   */
  toolName?: string | undefined;
  /**
   * Email of the user whose session produced the event, when present in hook attributes.
   */
  userEmail?: string | undefined;
};

/** @internal */
export const OnboardingHookEvent$inboundSchema: z.ZodMiniType<
  OnboardingHookEvent,
  unknown
> = z.pipe(
  z.object({
    chat_id: z.optional(z.string()),
    event_name: z.optional(z.string()),
    project_slug: z.string(),
    source: z.string(),
    status: z.optional(z.string()),
    time_unix_nano: z.string(),
    tool_name: z.optional(z.string()),
    user_email: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "chat_id": "chatId",
      "event_name": "eventName",
      "project_slug": "projectSlug",
      "time_unix_nano": "timeUnixNano",
      "tool_name": "toolName",
      "user_email": "userEmail",
    });
  }),
);

export function onboardingHookEventFromJSON(
  jsonString: string,
): SafeParseResult<OnboardingHookEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OnboardingHookEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OnboardingHookEvent' from JSON`,
  );
}
